<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps<{
    className: string
}>()
</script>

<template>
    <svg :class="props.className" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.5 3.5C20.1 3.1 19.5 3.1 19.1 3.5L12 10.6L4.9 3.5C4.5 3.1 3.9 3.1 3.5 3.5C3.1 3.9 3.1 4.5 3.5 4.9L10.6 12L3.5 19.1C3.1 19.5 3.1 20.1 3.5 20.5C3.9 20.9 4.5 20.9 4.9 20.5L12 13.4L19.1 20.5C19.5 20.9 20.1 20.9 20.5 20.5C20.9 20.1 20.9 19.5 20.5 19.1L13.4 12L20.5 4.9C20.9 4.5 20.9 3.9 20.5 3.5Z" fill="currentColor"></path>
    </svg>
</template>

<style scoped>

</style>
